import React from "react";
import PropTypes from "prop-types";

import { Centered } from "../../CardsStyled";
import { getTranslatedDate } from "utils/date-utils";
import { useTranslation } from "react-i18next";

export const AppointmentDetails = ({ rawEventDate, description }) => {
  const { i18n } = useTranslation();
  return (
    <Centered>
      <h3 className="success">
        {getTranslatedDate(rawEventDate, i18n.language).toUpperCase()}
      </h3>
      <p>{description}</p>
    </Centered>
  );
};

AppointmentDetails.propTypes = {
  rawEventDate: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default AppointmentDetails;
